export const help = {
  'help.diagram': 'Processing flowchart; the steps are also described in the article.',
  'help.diagramLoading': 'Drawing the flowchart…',
  'help.diagramFailed': 'Could not draw the flowchart. Read the steps in the article or the diagram source below.',
  'help.diagramSource': 'Diagram source (Mermaid)',
  'help.copyContext': 'Copy section context for an agent',
  'help.copyContextDetail': 'Copies the section and safe entry links. No patient or encounter identifiers or clinical text.',
  'help.contextCopied': 'Section context copied.',
  'help.contextCopyFailed': 'Could not copy the context. Try again.',
  'help.title': "Help",
  'help.description': "User guide for clinical documentation and patient files.",
  'help.downloadArchive': "Download all help (ZIP)",
  'help.downloadingArchive': "Preparing archive…",
  'help.archiveFailed': "Could not download the archive. Try again.",
  'help.archiveForbidden': "Your account does not have permission to download the archive.",
  'help.open': "Help for this screen",
  'help.center': "Open Help center",
  'help.search': "Search the guide",
  'help.topics': "Topics",
  'help.related': "Help for this section",
  'help.all': "All topics",
  'help.loading': "Loading help…",
  'help.failed': "Help could not be loaded.",
  'help.unavailable': "This topic is unavailable for your clinic or account.",
  'help.retry': "Try again",
  'help.empty': "No matching topics.",
  'help.notReady': "Help for this page is not ready yet.",
  'help.fallback': "This article is shown in {language}; the requested translation is not available.",
  'help.internal': "Internal — restricted",
  'help.contents': "On this page",
  'help.revision': "Revision {revision}",
  'help.language': "Article language",
} as const
